import { createContext, useContext, useState, useCallback } from "react";
import { Get_User_Wallet_Details } from "../apicall";

const WalletContext = createContext();

export const WalletProvider = ({ children }) => {

    const [wallet, setWallet] = useState(null);
    const [loading, setLoading] = useState(false);

    const refreshWallet = useCallback(async () => {
        try {
            setLoading(true);

            const data = await Get_User_Wallet_Details();
            //console.log(data);

            if (data.success) {
                setWallet(data?.Userwallet);
            }
        } finally {
            setLoading(false);
        }
    }, []);

    return (
        <WalletContext.Provider
            value={{
                wallet,
                loading,
                refreshWallet,
            }}
        >
            {children}
        </WalletContext.Provider>
    );
};

export const useWallet = () => useContext(WalletContext);